import ResultsViewModal from "./ResultsViewModal";

export default ResultsViewModal;
